// region-overview.jsx
import React, { Component } from "react";
import { OutboundLink } from "gatsby-plugin-google-gtag";

export default class RegionOverview extends Component {
  constructor(props) {
    super(props);
    this.state = {
      documents: this.props.data.documents || [],
      deadlineLabel: this.getDeadlineLabel(this.props.interest)
    };
  }

  getDeadlineLabel(interest) {
    console.log(`in getDeadlineLabel, changing label!`)
    return interest === 0 ? "Art Deadline" : interest === 1 ? "Writing Deadline" : "Region Deadline";
  }

  componentDidMount() {
    console.log(`🚀 RegionOverview Mounted! Initial Interest: ${this.props.interest}`);
    this.setState({
      deadlineLabel: this.getDeadlineLabel(this.props.interest),
    });
  }
  

  componentDidUpdate(prevProps) {
    if (prevProps.data.documents !== this.props.data.documents) {
      this.setState({ documents: this.props.data.documents });
    }
    console.log(`component did update, documents === `, this.state.documents);
    // 🔹 Update deadline label if interest changes
    if (prevProps.interest !== this.props.interest) {
      console.log(`🔄 Updating deadline label: ${prevProps.interest} → ${this.props.interest}`);
      this.setState({ deadlineLabel: this.getDeadlineLabel(this.props.interest) });
    }
  }

  render() {
    const { documents } = this.state;
    return (
      <div>
        <section id="region-page" className="page-pad">
          <div className="page">
            <div className="column-side">
              <div id="region-deadline" className="box special">
                {/* 🔹 Uses updated state to dynamically update the deadline */}
                <h4>{this.state.deadlineLabel}</h4>
                {new Date(this.props.data.submissionDeadlineDate).toDateString()}
                <div className="detail">
                  {new Date(this.props.data.submissionDeadlineDate).toLocaleTimeString()}
                </div>
              </div>
              <div style={{ paddingBottom: '30px' }}>
                <span>
                  <h3>Documents</h3>
                  <ul>
                  {Array.isArray(documents) && documents.length > 0 ? (
                      documents.map((doc, index) => (
                        <li key={index}>
                          <a
                            href={doc.key}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            {doc.title}
                          </a>
                        </li>
                      ))
                    ) : (
                      <li>No documents available</li>
                    )}
                  </ul>
                </span>
              </div>
            </div>
            <div className="column-main">
              <h3>Guidelines</h3>
              <span dangerouslySetInnerHTML={{ __html: this.props.data.guidelines }} />
              <h3>Announcements</h3>
              <span dangerouslySetInnerHTML={{ __html: this.props.data.announcements }} />
              <h3>Events</h3>
              <span dangerouslySetInnerHTML={{ __html: this.props.data.events }} />
            </div>
            <div className="column-side">
              <div className="box-group">
                <div id="region-partner-info" className="box">
                  <div id="region-partner-logo" style={{ backgroundImage: "url(" + this.props.data.logoKey + ")" }}></div>
                  <div id="region-partner-address">
                    {this.props.data.partnerName}
                    <br />
                    Attn:&nbsp;{this.props.data.contactName || null}
                    <br />
                    {this.props.data.contactPhone || null}
                    <br />
                  </div>
                  <div id="region-partner-contact">
                    {this.props.data.contactEmail ? (
                      <a href={`mailto:${this.props.data.contactEmail}?subject=Art%20%26%20Writing%20Awards`} className="button">
                        Send Message
                      </a>
                    ) : null}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    );
  }
}